import React from 'react';

/**
 * Enhanced lazy loading with retry logic to handle ChunkLoadError
 * @param {Function} componentImport - The import function () => import(...)
 * @param {number} retriesLeft - Number of retries before failing
 * @param {number} interval - Interval between retries in ms
 */
export const lazyWithRetry = (componentImport, retriesLeft = 3, interval = 1000) => {
  return React.lazy(() => 
    new Promise((resolve, reject) => {
      componentImport()
        .then(resolve)
        .catch((error) => {
          setTimeout(() => {
            if (retriesLeft <= 1) {
              reject(error);
              return;
            }
            lazyWithRetry(componentImport, retriesLeft - 1, interval).then(resolve, reject);
          }, interval);
        });
    })
  );
};

export default lazyWithRetry;
